import React from 'react'
import Centered from 'shared/ui/Centered'
import './Hero.scss'

export function Hero({ children }) {
  return (
    <div className="hero">
      <Centered>
        <div className="hero-body">{children}</div>
      </Centered>
    </div>
  )
}

export function HeroPrimaryContent({ children }) {
  return <div className="hero-primary-content">{children}</div>
}
